export enum ReminderEnum {
  EMAIL_REMINDER = 'EMAIL_REMINDER',
  PHONE_REMINDER = 'PHONE_REMINDER'
}

export const reminderEnumMapping: Record<ReminderEnum, string> = {
  [ReminderEnum.EMAIL_REMINDER]: 'Email',
  [ReminderEnum.PHONE_REMINDER]: 'Téléphone'
}
